import { oktaAuth } from "../okta";

export interface ScUserClaims {
  name: string;
  givenName: string;
  familyName: string;
}

// Fetches all user claims in a single Okta request.
export const getScUserClaims = async (): Promise<ScUserClaims> => {
  const userClaims = await oktaAuth.getUser();
  return {
    name: userClaims.name || "",
    givenName: (userClaims.given_name as string) || "",
    familyName: (userClaims.family_name as string) || "",
  };
};

// Retrieves SafetyCulture users name from local storage
// Needed in payload for some endpoints like delete organisation
export const getScUserName = async () => {
  const claims = await getScUserClaims();
  return claims.name;
};
